import { useEffect } from 'react';
import { useListStore } from './hooks/useListStore';
import { MenuCategoryPageView } from './MenuCategoryPageView';

export const MenuCategoryPage = () => {
  const { fetchMenuCategories } = useListStore();

  useEffect(() => {
    void fetchMenuCategories();
  }, [fetchMenuCategories]);

  return <MenuCategoryPageView />;
};
